import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import _ from "lodash";
import { useQuery } from "@apollo/client";

// import gqlProviders from "../../../../gql/providers";

function FilterModal({
  showFilter,
  setShowFilter,
  refetch,
  setPageNo,
  setLimit,
  refetchExcelDataResponse,
}) {
  const [providers, setProviders] = useState([]);

  const modalRef = useRef();

  const addData = (values) => {
    let data = _.cloneDeep(values);
    setPageNo(1);
    let obj = {
      name: values.name,
      document_id: values.document_id,
      license: values.license,
      limit: 10,
      page: 1,
    };

    // console.log("obj :: ", obj);

    refetch({ limit: 21, page: 1 });

    delete obj.limit;
    delete obj.page;

    refetchExcelDataResponse({
      input: Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (value !== "" && value !== null) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowFilter(false);
      }
    };

    if (showFilter) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilter]);

  return (
    <div className={`${showFilter ? "open" : ""} modal`} id="myModal">
      <Formik
        initialValues={{
          name: "",
          document_id: "",
          license: "",
        }}
        validate={(values) => {
          const errors = {};
        }}
        onSubmit={(values, { setSubmitting }) => {
          addData(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          resetForm,
          /* and other goodies */
        }) => (
          <div ref={modalRef} className="modal-content">
            <div
              className="close"
              onClick={() => setShowFilter(() => !showFilter)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                  fill="#DE5042"
                />
              </svg>
              <div className="bene-text">Physicians</div>
            </div>
            <div className="search-fields">
              <input
                placeholder="Name"
                type="text"
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                id="name"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
              <input
                placeholder="Document ID"
                type="text"
                name="document_id"
                value={values.document_id}
                onChange={handleChange}
                onBlur={handleBlur}
                id="document_id"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
              <input
                placeholder="License Number"
                type="text"
                name="license"
                value={values.license}
                onChange={handleChange}
                onBlur={handleBlur}
                id="license"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <div
              className="search-btn"
              onClick={() => {
                handleSubmit();
                setShowFilter(false);
              }}
            >
              {/* <div className="search-btn" onClick={handleSubmit}> */}
              <span>Search</span>
            </div>
            <div className="reset-btn" onClick={resetForm}>
              <span>Reset</span>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
}

export default FilterModal;

// const formatProvidersData = (data) => {
//   let returnData = [];
//   if (data?.length > 0) {
//     data.map((item) => {
//       returnData.push({
//         id: item.ID,
//         name: item.NameEn,
//       });
//     });
//   } else {
//   }
//   return returnData;
// };

// const {
//   loading: loadingProviders,
//   error: errorProvider,
//   data: providersData,
//   refetch: refetchProviders,
// } = useQuery(gqlProviders.GET_ALL_PROVIDERS_WITHOUT_PAGINATION);

// React.useEffect(() => {
//   if (providersData) {
//     setProviders(formatProvidersData(providersData?.getAllProviders?.Data));
//   }
// }, [providersData]);
